import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { API_BASE_URL } from "../config/apiConfig";

const PaymentSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const reference = params.get("reference"); // Paystack reference
        const userId = params.get("user_id");      // your user_id
        const trxref = params.get("trxref");       // optional trxref

        if (reference && userId) {
            const verifyPayment = async () => {
                try {
                    const token = localStorage.getItem("token");
                    const res = await fetch(`${API_BASE_URL}/api/sub/verify/${reference}?user_id=${userId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    const data = await res.json();

                    if (data.status === "success") {
                        window.dispatchEvent(new CustomEvent("subscription-updated", { detail: true }));
                        navigate(-1); // go back one step in history
                    } else {
                        toast.error("Payment verification failed");
                    }
                } catch (err) {
                    console.error(err);
                    toast.error("Error verifying payment");
                }
            };

            verifyPayment();
        }
    }, [location, navigate]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-2xl font-bold">Processing Payment...</h1>
            <p className="mt-2">Please wait while we verify your subscription.</p>
        </div>
    );
};

export default PaymentSuccess;
